import { useQuery } from "@apollo/client/react";

import { graphql } from "../../../../../../__generated__/gql";
import type {
  AccommodationFeeRuleType,
  FeeModifierType,
} from "../../../../../../__generated__/gql/graphql";
import type { buildAccommodationReservationProviderInput } from "../../../../../../utils";

const StayTicketFeeDiscountsOnCheckoutDatePickerDrawerQuery = graphql(`
  query StayTicketFeeDiscountsOnCheckoutDatePickerDrawer(
    $stayTicketUnitId: ID!
  ) {
    stayTicketReservationInfo(stayTicketUnitId: $stayTicketUnitId) {
      discounts {
        ruleType
        night
        feeModifier
        feeModifierType
      }
    }
  }
`);

/** チケットの料金割引1件 (連泊割引 / 特定泊の値引き)。 */
export type StayTicketFeeDiscount = {
  ruleType: AccommodationFeeRuleType;
  night: number;
  feeModifier: number;
  feeModifierType: FeeModifierType;
};

type UseStayTicketFeeDiscountsParams = {
  provider: ReturnType<typeof buildAccommodationReservationProviderInput>;
};

type UseStayTicketFeeDiscountsResult = {
  /** チケットマスタの料金割引すべて (night 昇順)。非 StayTicket / 割引なしは空配列。 */
  feeDiscounts: StayTicketFeeDiscount[];
};

/**
 * チケットマスタの料金割引 (CI 非依存) を取得する。
 * StayTicket 以外 (providerStayTicketUnitId なし) は fetch しない (skip)。
 * 料金割引は滞在日数に依存しない不変値のため、複数回開いても Apollo cache hit を期待できる。
 */
export function useStayTicketFeeDiscounts({
  provider,
}: UseStayTicketFeeDiscountsParams): UseStayTicketFeeDiscountsResult {
  const stayTicketUnitId = provider.providerStayTicketUnitId ?? null;
  const skip = stayTicketUnitId === null;

  const { data } = useQuery(
    StayTicketFeeDiscountsOnCheckoutDatePickerDrawerQuery,
    {
      skip,
      // skip=true の場合は実行されないため、空文字をプレースホルダーとして使用
      variables: { stayTicketUnitId: stayTicketUnitId ?? "" },
    },
  );

  const feeDiscounts = skip
    ? []
    : (data?.stayTicketReservationInfo?.discounts ?? []);

  return { feeDiscounts };
}
